import React from 'react';
import { NavFooterIcon } from '@capcenter/shared';
import { subDays, isAfter } from 'date-fns';

import './ListingStatus.scss';

function ListingStatus({ isCapcenterPurchase, isCapcenterListing, onMarket, listingStatus, listItem, closeDate }: {
	isCapcenterPurchase: boolean | undefined,
	isCapcenterListing: boolean | undefined,
	onMarket: Date | undefined,
	listingStatus: string | undefined,
	listItem?: boolean,
	closeDate: Date,
}) {
	let inTheLastWeek = false;
	if (onMarket) {
		const today = new Date();
		const aWeekAgo = subDays(today, 7);
		const compare = new Date(onMarket);
		inTheLastWeek = isAfter(compare, aWeekAgo);
	}

	const isPending = (listingStatus?.toLowerCase() === 'pending' || listingStatus?.toLowerCase() === 'under contract');

	let colorClassName = 'listing-status-accent';

	if (closeDate) {
		colorClassName = 'listing-status-slate';
	}
	else if (isPending) colorClassName = 'listing-status-accent';
	else if (inTheLastWeek) colorClassName = 'listing-status-green';

	if (isCapcenterListing || isCapcenterPurchase) {
		colorClassName = 'listing-status-primary';
	}

	const closeDateObject = new Date(closeDate);
	const closeDateMonth = closeDateObject && closeDateObject.toLocaleString('default', { month: 'short' });
	const closeDateDay = closeDateObject && closeDateObject.getDate();
	const closeDateMonthNumber = closeDateObject && (closeDateObject.getMonth() + 1);  // Modified date display to fit inside property card pill
	const closeDateYear = closeDateObject && closeDateObject.getFullYear();
	const closeDateString = listItem ?
		`Sold ${closeDateMonthNumber}/${closeDateDay}/${closeDateYear}` :
		`Sold on ${closeDateMonth} ${closeDateDay}, ${closeDateYear}`;


	const ListingStatusElement = ({ closeDate, inTheLastWeek, isCapcenterListing, listItem }: { closeDate: Date, inTheLastWeek: boolean, isCapcenterListing?: boolean, listItem?: boolean }) => {

		if (listItem) {
			const content = closeDate ? closeDateString : 'CapCenter';
			if (isCapcenterListing) {
				if (isPending) {
					return <>
						<NavFooterIcon icon="capcenter" />
						<span className="ms-1">{'Pending'}</span>
					</>;
				} else {
					return <>
						<NavFooterIcon icon="capcenter" />
						<span className="ms-1">{content}</span>
					</>;
				}
			} else if (closeDate) {
				return <>{content}</>;
			}
			else if (isPending) {
				return <>Pending</>;
			}
			else if (inTheLastWeek) {
				return <>New</>;
			}
			else return <>{listingStatus}</>;
		} else {
			if (isCapcenterListing) {
				return <>
					<NavFooterIcon icon="capcenter" />
					<span className="ms-1">{'Capcenter Listing'}</span>
					{closeDate && <div className='mt-1' >{closeDateString}</div>}
				</>;
			} else if (isCapcenterPurchase) {
				return <>
					<NavFooterIcon icon="capcenter" />
					<span className="ms-1">{'Capcenter Purchase'}</span>
					{closeDate && <div className='mt-1' >{closeDateString}</div>}
				</>;
			} else if (closeDate) {
				return <>{closeDateString}</>;
			}
			else if (isPending) {
				return <>Pending</>;
			}
			else if (inTheLastWeek) {
				return <>New Listing</>;
			}
			else return <>{listingStatus}</>;
		}
	};



	const ListingStatus =
		<div className={`listing-status ${colorClassName}`} >
			<ListingStatusElement closeDate={closeDate} inTheLastWeek={inTheLastWeek} isCapcenterListing={isCapcenterListing} listItem={listItem} />
		</div>;


	if (listItem && (!closeDate && !isCapcenterListing && !inTheLastWeek && listingStatus?.toLowerCase() !== 'pending')) {
		return <></>;
	} else return ListingStatus;
}

export default ListingStatus;
